<template>
  <div class="hello mt-5 p-5">
    <h1 class="font-weight-bolder">About me</h1>
   <p  class=" pt-5 introduction ">  Hello! I am Mario Moncada. Im Frontend developer from Colombia. I enjoy the process of create web aplications and interactive user interfaces.
       </p>
       <p class=" introduction ">My favorite JAVASCRIPT frameworks is Vue.js but i have knowledge in React.js also.</p>
       <div>
<h2 class="font-weight-bolder  mt-5">
  What i think about technology
</h2>
<p  class=" introduction ">Technology is one of the tools more important right now,
   technology is everywhere, when technology is used to improve process, connect people, manage data. it makes life easier.   </p>

       </div>

       <div>
         <h3 class="font-weight-bolder ">Technologies</h3>
         <p  class="pt-5  introduction ">This is a list with the gruop of tools and frameworks that i have learned... </p>
         <ul >
           <li>HTML </li>
           <li>CSS</li>
           <li>BOOTSTRAP</li>
           <li>JAVASCRIPT</li>
           <li>VUE.JS</li>
           <li>REACT.JS</li>
           <li>GIT</li>
         </ul>
       </div>
       <h2>{{msg}}</h2>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.introduction{
  font-size: 20px;;
}
</style>
